'use strict';
const placeCaretAtEnd = require('./place-caret-at-end'),
	selectAll = require('./select-all');

module.exports = function editNode(stageDOM, nodeDOM, layoutNode, shouldSelectAll) {
	if (!stageDOM || !nodeDOM || !layoutNode) {
		throw new Error('invalid-args');
	}
	const textBoxDOM = nodeDOM.querySelector('[data-mapjs-role=title]'),
		unformattedText = layoutNode.title.trim(),
		oldWidth = textBoxDOM.style.width,
		stageCanvas = stageDOM.querySelector('[data-mapjs-role="svg-container"]'),
		oldBackgroundColor = nodeDOM.style.backgroundColor,
		originalText = textBoxDOM.innerText.trim();


	if (unformattedText !== originalText) { /* links or some other potential formatting issues */
		textBoxDOM.style.wordBreak = 'break-all';
	}
	textBoxDOM.innerText = unformattedText;
	textBoxDOM.setAttribute('contenteditable', true);
	if (oldBackgroundColor === 'transparent') {
		textBoxDOM.style.backgroundColor = stageCanvas.style.backgroundColor;
	}
	textBoxDOM.style.width = '';
	textBoxDOM.style.display = '';
	textBoxDOM.focus();
	if (shouldSelectAll) {
		selectAll(textBoxDOM);
	} else if (unformattedText) {
		placeCaretAtEnd(textBoxDOM);
	}
	nodeDOM.removeAttribute('draggable');
	stageDOM.removeAttribute('draggable');
	nodeDOM.classList.add('editing');
	return new Promise((resolve, reject) => {
		const clear = function () {
				detachListeners(); //eslint-disable-line no-use-before-define
				textBoxDOM.removeAttribute('contenteditable');
				textBoxDOM.style.wordBreak = '';
				textBoxDOM.style.width = oldWidth;
				textBoxDOM.style.backgroundColor = '';
				nodeDOM.setAttribute('draggable', 'true');
				stageDOM.setAttribute('draggable', 'true');
				nodeDOM.classList.remove('editing');
			},
			isBlurOutsideDocument = e => {
				return e.isTrusted && e.type === 'blur' && textBoxDOM.ownerDocument.activeElement === textBoxDOM;
			},
			finishEditing = function (e) {
				if (isBlurOutsideDocument(e)) {
					return;
				}
				const content = textBoxDOM.innerText;
				if (content === unformattedText) {
					return cancelEditing(e); //eslint-disable-line no-use-before-define
				}
				clear();
				resolve(content);
			},
			cancelEditing = function (e) {
				clear();
				textBoxDOM.innerText = originalText;
				reject(e?.type);
			},
			keyboardEvents = function (e) {
				const ENTER_KEY_CODE = 13,
					ESC_KEY_CODE = 27,
					TAB_KEY_CODE = 9,
					S_KEY_CODE = 83,
					Z_KEY_CODE = 90,
					completedEvent = new Event('keydown-complete');
				if (e.which === ENTER_KEY_CODE && !e.shiftKey) { // allow shift+enter to break lines
					finishEditing(e);
					e.stopPropagation();
				} else if (e.which === ESC_KEY_CODE) {
					cancelEditing(e);
					e.preventDefault();
					e.stopPropagation();
				} else if (e.which === TAB_KEY_CODE || (e.which === S_KEY_CODE && (e.metaKey || e.ctrlKey) && !e.altKey)) {
					finishEditing(e);
					e.preventDefault(); /* stop focus on another object */
				} else if (!e.shiftKey && e.which === Z_KEY_CODE && (e.metaKey || e.ctrlKey) && !e.altKey) { /* undo node edit on ctrl+z if text was not changed */
					if (textBoxDOM.innerText === unformattedText) {
						cancelEditing(e);
					}
					e.stopPropagation();
				}
				completedEvent.relatedEvent = e;
				textBoxDOM.dispatchEvent(completedEvent);
			},
			attachListeners = function () {
				textBoxDOM.addEventListener('blur', finishEditing);
				textBoxDOM.addEventListener('keydown', keyboardEvents);
			},
			detachListeners = function () {
				textBoxDOM.removeEventListener('blur', finishEditing);
				textBoxDOM.removeEventListener('keydown', keyboardEvents);
			};
		attachListeners();
	});
};

